import { render, staticRenderFns } from "./captchaDialog.vue?vue&type=template&id=2ffc10b6&scoped=true"
import script from "./captchaDialog.vue?vue&type=script&lang=js"
export * from "./captchaDialog.vue?vue&type=script&lang=js"
import style0 from "./captchaDialog.vue?vue&type=style&index=0&id=2ffc10b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffc10b6",
  null
  
)

export default component.exports